import { render, staticRenderFns } from "./GenericKpi.vue?vue&type=template&id=28347e2e&scoped=true&"
import script from "./GenericKpi.vue?vue&type=script&lang=js&"
export * from "./GenericKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28347e2e",
  null
  
)

export default component.exports